import {createTheme} from '@mui/material/styles'

const theme_one = createTheme({
	typography:{
		htmlFontSize:18,
		fontSize:18,
		body1:{
            color:"#333",
            fontSize:18
        },
		h1:{
			fontWeight:"bold",
			color:"black",
			fontSize:40,
		}
	},
	components:{
		MuiAlert:{
			styleOverrides: {
        		message: {
					fontSize:18,
				}
			}
		}
	}
})

export default theme_one
